var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "37px",
    viewBox: "0 0 37 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dots-bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-1-mixed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-350.000000, -990.000000)",
    fill: "#454360",
    id: "about"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.000000, 990.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section-title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dots-bg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 11,
    y: 0,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 22,
    y: 0,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 33,
    y: 0,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 11,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 11,
    y: 11,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 22,
    y: 11,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 33,
    y: 11,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 0,
    y: 22,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 11,
    y: 22,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 22,
    y: 22,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 33,
    y: 22,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 0,
    y: 33,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 11,
    y: 33,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 22,
    y: 33,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 33,
    y: 33,
    width: 4,
    height: 4,
    rx: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsBg);
export default __webpack_public_path__ + "static/media/dots-bg.aa8289c51cd678b8cd47d818f1191d43.svg";
export { ForwardRef as ReactComponent };